import { useTranslations } from '@vocab/react';
import { Box, Stack, Text } from 'braid-design-system';

import PictureThumbnail from '../../../SharedComponent/PictureThumbnail/PictureThumbnail';
import translations from '../../.vocab';

import imageCenter from './images/image_center.jpg';
import imageLeft from './images/image_left.jpg';
import imageRight from './images/image_right.jpg';

import * as styles from './SocialProofSection.css';

const SocialProofSection = () => {
  const { t } = useTranslations(translations);
  return (
    <Stack space="small">
      <Box
        gap="xxsmall"
        display="flex"
        justifyContent="flexStart"
        alignItems="center"
        marginTop="xxsmall"
      >
        <Box className={styles.thumbnailsContainer}>
          <PictureThumbnail
            imageSrc={imageLeft}
            imageAlt=""
            size="xsmall"
            thumbnailStyle={styles.thumbnail.left}
          />
          <PictureThumbnail
            imageSrc={imageCenter}
            imageAlt=""
            size="xsmall"
            thumbnailStyle={styles.thumbnail.center}
          />
          <PictureThumbnail
            imageSrc={imageRight}
            imageAlt=""
            size="xsmall"
            thumbnailStyle={styles.thumbnail.right}
          />
        </Box>
        <Box marginLeft="xxsmall">
          <Text size="small" tone="secondary">
            {t(
              '73% found the refinement helpful in surfacing better-matched roles.',
            )}
          </Text>
        </Box>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        className={styles.quoteBlock}
        flexGrow={1}
      >
        <Text size="small" tone="secondary">
          {t(
            "Seek's recommendations helped me cut through the noise — it felt like the jobs were picked just for me.",
          )}
        </Text>
      </Box>
    </Stack>
  );
};

export default SocialProofSection;
